// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"2de6d5ed","652":"2de6d5ed"}[chunkId] + ".chunk.css";
};